var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardbox"},[_c('div',{staticClass:"card__box",style:({
      'border-color': _vm.borderColor,
      backgroundColor: _vm.backgroundColor,
      'border-radius': '12px',
    })},[_c('h6',{staticClass:"pb-3",style:({ color: _vm.titleColor, 'text-align': _vm.title_alignment })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("conteudo"),_vm._t("footerImage")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }